import { render, staticRenderFns } from "./dialog_off_lesson.vue?vue&type=template&id=60dc9768&scoped=true"
import script from "./dialog_off_lesson.vue?vue&type=script&lang=js"
export * from "./dialog_off_lesson.vue?vue&type=script&lang=js"
import style0 from "./dialog_off_lesson.vue?vue&type=style&index=0&id=60dc9768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dc9768",
  null
  
)

export default component.exports